import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-market-place-info',
  templateUrl: 'market-place-info.html',
})
export class MarketPlaceInfoPage {
  osName: string;
  marketPlaceName: string;
  buttonText: string;
  marketingText: string;
  badgePath: string;
  marketPlaceUrl = {
    Android: 'https://play.google.com/store/apps/details?id=com.siemens.myhealthmobile',
    iOS: 'https://itunes.apple.com/app/siemens-myhealth/id1481065207'
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController,
    private inAppBrowser: InAppBrowser) {
    this.osName = navParams.data.osName;
    if (this.osName === 'Android') {
      this.marketPlaceName = 'Google Play';
      this.buttonText = 'Get it on Google Play';
      this.marketingText = 'Try an even faster and easier myHealth on Google Play!';
      this.badgePath = '../../assets/imgs/google-play-badge.png';
    } else {
      this.marketPlaceName = 'AppStore';
      this.buttonText = 'Available on the App Store';
      this.marketingText = 'Try an even faster and easier myHealth on the App Store!';
      this.badgePath = '../../assets/imgs/appstore-badge.svg';
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  goToMarketPlace() {
    this.inAppBrowser.create(this.marketPlaceUrl[this.osName], '_blank', {
      clearcache: 'yes'
    }).show();
  }

}



// WEBPACK FOOTER //
// ./src/pages/market-place-info/market-place-info.ts